import {VorhersageMesswerte} from './vorhersage-messwerte';
import {Ort} from '../common/ort';


class AbstractVorhersageTag {
  eingangsdatum: Date;
  erstellungsdatum: Date;
  mosmixmodell: string;
  ort: Ort;
}

export class VorhersageZehnTage extends AbstractVorhersageTag {

  tag00?: VorhersageTag;
  tag01: VorhersageTag;
  tag02: VorhersageTag;
  tag03: VorhersageTag;
  tag04: VorhersageTag;
  tag05: VorhersageTag;
  tag06: VorhersageTag;
  tag07: VorhersageTag;
  tag08: VorhersageTag;
  tag09: VorhersageTag;
  tag10: VorhersageTag;


  public getTagesListe(): VorhersageTag[] {
    let alleTage = [this.tag00, this.tag01, this.tag02, this.tag03, this.tag04, this.tag05, this.tag06, this.tag07, this.tag08, this.tag09, this.tag10];
    return alleTage.filter(tag => tag !== undefined && tag !== null);
  }

}

export class VorhersageHeute extends AbstractVorhersageTag {
  tag00: VorhersageTag;
}

export class VorhersageTag {
  ['00:00-00:00']: VorhersageMesswerte;
  werteGanzerTag: VorhersageMesswerte;
  //EINE INTERNE VARIABLE, UM DIE TABELLEN RICHTIG ZU GENERIEREN
  // ERLAUBTE WERTE: 24h | 3h
  id: string;
  //Für die 3h Werte
  ['00:00-03:00']: VorhersageMesswerte;
  ['03:00-06:00']: VorhersageMesswerte;
  ['06:00-09:00']: VorhersageMesswerte;
  ['09:00-12:00']: VorhersageMesswerte;
  ['12:00-15:00']: VorhersageMesswerte;
  ['15:00-18:00']: VorhersageMesswerte;
  ['18:00-21:00']: VorhersageMesswerte;
  ['21:00-00:00']: VorhersageMesswerte;
  werteListeDreiStunden: VorhersageMesswerte[];

  constructor() {
  }
}



